import * as actionTypes from '../actions/ActionTypes';

const LoginReducer = (state = { canShow: false, message: '' }, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_INTERNET_STATUS:
      return {
        ...state,
        isNetConnected: action.isNetConnected,
      };

    case actionTypes.FORGET_PASSWORD_REQUEST:
      return {
        ...state,

        isChecking: action.isChecking,
      };

    case actionTypes.SHOW_FORGOT_MODAL:
      return {
        ...state,
        canShow: action.canShow,
        message: action.message,
      };
    case actionTypes.RESET_PASSWORD:
      return {
        ...state,

        resetPasswordField: action.isPasswordFieldReset,
      };
    case actionTypes.LOGIN_STATUS:
      return {
        ...state,
        loginStatue: action.loginStatue,
      };

    // case actionTypes.LOGOUT: {
    //   return {
    //     ...state,
    //     loginStatue: 3
    //   };
    // }

    default:
      return state;
  }
};

export default LoginReducer;
